import * as React from "react";
import { george, ui, pr, } from "aaa";
import externalInterfaceStore from "stores/ExternalInterfaceStore";
import { observer } from "mobx-react";
import { mobileSummaryStyle, summaryStyle, summaryElementLabelStyle } from "./styles";
import { TradingPreferencesStore } from "./TradingPreferencesStore";

export const TradingPreferencesSummary = observer(({ store }: { store: TradingPreferencesStore, }) => {
    const isMobile = externalInterfaceStore.isGeorgeApp || ui.windowWidth < 600;

    const summaryElementStyles = isMobile
        ? mobileSummaryStyle
        : summaryStyle;



    const summaryElementBackgroundStyle = {
        ...summaryElementLabelStyle,
        backgroundColor: ui.isDarkMode ? "#3A3A3C" : "#EFF1F5",
    };

    return (
        <div style={{ padding: 32 }}>
            <pr.P_18_TITLE style={{ fontWeight: 700, lineHeight: "24px", color: ui.isDarkMode ? "white" : "#0A285C" }}>
                {ui.__("tradingPreferences.summary.title")}
            </pr.P_18_TITLE>
            <div style={{ marginTop: 8 }}>
                {store.preferences.map((preference, index) => (
                    <george.ResponsiveSummaryElement
                        label={preference.itemName}
                        style={index % 2 !== 0 ? summaryElementBackgroundStyle : summaryElementLabelStyle}
                        {...summaryElementStyles}
                    >
                        <pr.SigningLabel>
                            {preference.enabled ? ui.__("tradingPreferences.summary.enabled") : ui.__("tradingPreferences.summary.disabled")}
                        </pr.SigningLabel>
                    </george.ResponsiveSummaryElement>
                ))}
            </div>
        </div>
    );
});


// WEBPACK FOOTER //
// ./src/components/tradingPreferences/TradingPreferencesSummary.tsx